// FIXME: Update this configuration file based on your project information
export const AppConfig = {
  name: 'CertResource.com',
  locales: ['en'],
  defaultLocale: 'en',
};
